// import {
//    Button,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalFooter,
//    ModalBody,
//    ModalCloseButton,
//    useColorModeValue,
//    Grid,
//    GridItem,
// } from '@chakra-ui/react';
// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { getBrand } from '../../../../redux/actions/brand';
// import { getCategory } from '../../../../redux/actions/category';
// import { getSeries } from '../../../../redux/actions/series';
// import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
// import { RAM_TYPE, STORAGE_TYPE } from '../../../../variables/company';
// import { getColor } from '../../../../redux/actions/color';
// import { getReportStockDetail } from '../../../../redux/actions/reports';
// import { useUser } from 'contexts';
// import { getDaybook } from '../../../../redux/actions/daybook';
// import { getAccount } from '../../../../redux/actions/account';
// import { getItems } from '../../../../redux/actions/item';
// import { useGlobal } from 'contexts';
// import MultiSelectDropdown from 'components/ui/MultiSelectDropdown';
// import AddEditForm from '../../masters/Pages/AllAccountMaster/AddEditFormForAccount';

// function StockFilter({ isOpen, onClose, companyIds, fromDate, toDate, stockStatus }) {
//    const { user } = useUser();
//    const dispatch = useDispatch();
//    const { userGlobalSettingsData } = useGlobal();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const isColorMode = useColorModeValue(true, false);
//    const brandData = useSelector((state) => state.brand.list || []);
//    const categoryData = useSelector((state) => state.category.list || []);
//    const seriesData = useSelector((state) => state.series.list || []);
//    const colorData = useSelector((state) => state.color.list || []);
//    const accountData = useSelector((state) => state.account.list || []);
//    const itemData = useSelector((state) => state.item.data || []);
//    const daybookData = useSelector((state) => state.daybook.list || []);
//    const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
//    const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
//    const globalSettingDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook;
//    const shouldShowCompanyDropdownDaybook = globalSettingDaybook || false;
//    const globalSettingItem = userGlobalSettingsData?.[0]?.askCompany?.item;
//    const shouldShowCompanyDropdownItem = globalSettingItem || false;
//    const globalSettingBrand = userGlobalSettingsData?.[0]?.askCompany?.brand;
//    const shouldShowCompanyDropdownBrand = globalSettingBrand || false;
//    const globalSettingCategory = userGlobalSettingsData?.[0]?.askCompany?.category;
//    const shouldShowCompanyDropdownCategory = globalSettingCategory || false;
//    const globalSettingSeries = userGlobalSettingsData?.[0]?.askCompany?.series;
//    const shouldShowCompanyDropdownSeries = globalSettingSeries || false;
//    const globalSettingColor = userGlobalSettingsData?.[0]?.askCompany?.color;
//    const shouldShowCompanyDropdownColor = globalSettingColor || false;

//    useEffect(() => {
//       if (isOpen) {
//          dispatch(
//             getBrand({
//                ...(shouldShowCompanyDropdownBrand &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getCategory({
//                ...(shouldShowCompanyDropdownCategory &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getSeries({
//                ...(shouldShowCompanyDropdownSeries &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getColor({
//                ...(shouldShowCompanyDropdownColor &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getItems({
//                companyId: user.loginhistory.companyId,
//                ...(shouldShowCompanyDropdownItem &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//                status: true,
//             }),
//          );
//          dispatch(
//             getAccount({
//                compId: user?.loginhistory?.companyId,
//                ...(shouldShowCompanyDropdownAcc &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//          dispatch(
//             getDaybook({
//                companyId: user.loginhistory.companyId,
//                ...(shouldShowCompanyDropdownDaybook &&
//                   companyIds?.length && {
//                   companyIds: companyIds.join(','),
//                }),
//             }),
//          );
//       }
//    }, [
//       companyIds,
//       dispatch,
//       isOpen,
//       shouldShowCompanyDropdownAcc,
//       shouldShowCompanyDropdownBrand,
//       shouldShowCompanyDropdownCategory,
//       shouldShowCompanyDropdownColor,
//       shouldShowCompanyDropdownDaybook,
//       shouldShowCompanyDropdownItem,
//       shouldShowCompanyDropdownSeries,
//       user,
//    ]);

//    const initialFormData = {
//       colorIds: [],
//       ram: '',
//       seriesIds: [],
//       categoryIds: [],
//       brandIds: [],
//       storage: '',
//       accountIds: [],
//       itemIds: [],
//       daybookIds: [],
//    };

//    const [formData, setFormData] = useState(initialFormData);

//    const handleBrandChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, brandIds: selectedValues || [] }));
//    };

//    const handleCategoryChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, categoryIds: selectedValues || [] }));
//    };

//    const handleSeriesChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, seriesIds: selectedValues || [] }));
//    };

//    const handleColorChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, colorIds: selectedValues || [] }));
//    };

//    const handleAccountChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, accountIds: selectedValues || [] }));
//    };

//    const handleItemChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, itemIds: selectedValues || [] }));
//    };

//    const handleDaybookChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, daybookIds: selectedValues || [] }));
//    };

//    const handleInputChange = (name, value) => {
//       setFormData((prev) => ({
//          ...prev,
//          [name]: value,
//       }));
//    };

//    // Helper function to check if a value has content
//    const hasValue = (value) => {
//       if (Array.isArray(value)) {
//          return value.length > 0;
//       }
//       return value !== '' && value !== null && value !== undefined;
//    };

//    const handleSubmit = (e) => {
//       e.preventDefault();

//       // Base payload with required fields
//       const payload = {
//          companyIds: companyIds.toString(),
//          fromDate: fromDate,
//          toDate: toDate,
//          stockStatus: stockStatus,
//       };

//       // Only add fields that have values
//       if (hasValue(formData.colorIds)) {
//          payload.colorIds = formData.colorIds.toString();
//       }

//       if (hasValue(formData.ram)) {
//          payload.rams = formData.ram.toString();
//       }

//       if (hasValue(formData.seriesIds)) {
//          payload.seriesIds = formData.seriesIds.toString();
//       }

//       if (hasValue(formData.categoryIds)) {
//          payload.categoryIds = formData.categoryIds.toString();
//       }

//       if (hasValue(formData.brandIds)) {
//          payload.brandIds = formData.brandIds.toString();
//       }

//       if (hasValue(formData.storage)) {
//          payload.storages = formData.storage.toString();
//       }

//       if (hasValue(formData.accountIds)) {
//          payload.accIds = formData.accountIds.toString();
//       }

//       if (hasValue(formData.itemIds)) {
//          payload.itemIds = formData.itemIds.toString();
//       }

//       if (hasValue(formData.daybookIds)) {
//          payload.daybookIds = formData.daybookIds.toString();
//       }

//       dispatch(getReportStockDetail(payload));
//       onClose();
//    };

//    const handleClear = () => {
//       // Reset all form fields to initial state
//       setFormData(initialFormData);

//       // Create payload with only required fields (no filters)
//       const payload = {
//          companyIds: companyIds.toString(),
//          fromDate: fromDate,
//          toDate: toDate,
//          stockStatus: stockStatus,
//       };

//       // Dispatch with cleared filters
//       dispatch(getReportStockDetail(payload));
//    };

//    return (
//       <Modal isOpen={isOpen} onClose={onClose} size="xl">
//          <ModalOverlay />
//          <ModalContent as="form" onSubmit={handleSubmit}>
//             <ModalHeader>Stock Filter</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody pb={6}>
//                <Grid templateColumns="repeat(2, 1fr)" gap={4}>
//                   <GridItem>
//                      {/* {renderDynamicDropdown(
//                         'accountid',
//                         'Account',
//                         accountData,
//                         {
//                            value: formData.accountIds,
//                            onChange: handleAccountChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'account',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Account',
//                         true,
//                         undefined,
//                         true,
//                      )} */}
//                      <MultiSelectDropdown
//                         label="Account"
//                         options={accountData}
//                         value={formData.accountIds}
//                         onChange={handleAccountChange}
//                         placeholder="Select Account"
//                         isRequired={true}
//                         showAddButton={true}
//                         onAddNew={(value) => console.log("handleAddNew", value)}
//                         isLoading={false}
//                         darkMode={!isColorMode}
//                         AddEditFormComponent={AddEditForm}
//                         error={""}
//                      />
//                   </GridItem>
//                   {/* Daybook Dropdown */}
//                   <GridItem>
//                      {renderDynamicDropdown(
//                         'daybookid',
//                         'Daybook',
//                         daybookData,
//                         {
//                            value: formData.daybookIds,
//                            onChange: handleDaybookChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'daybook',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Daybook',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem>

//                   <GridItem>
//                      {renderDynamicDropdown(
//                         'itemid',
//                         'Item',
//                         itemData,
//                         {
//                            value: formData.itemIds,
//                            onChange: handleItemChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'item',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Item',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem>
//                   {/* Brand Dropdown */}
//                   <GridItem>
//                      {renderDynamicDropdown(
//                         'brandid',
//                         'Brand',
//                         brandData,
//                         {
//                            value: formData.brandIds,
//                            onChange: handleBrandChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'brand',
//                         },
//                         {},
//                         textColor,
//                         true,
//                         'Select Brand',
//                         false,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem>

//                   {/* Category Dropdown */}
//                   <GridItem>
//                      {renderDynamicDropdown(
//                         'categoryid',
//                         'Category',
//                         categoryData,
//                         {
//                            value: formData.categoryIds,
//                            onChange: handleCategoryChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'category',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Category',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem>

//                   {/* Series Dropdown */}
//                   <GridItem>
//                      {renderDynamicDropdown(
//                         'seriesId',
//                         'Series',
//                         seriesData,
//                         {
//                            value: formData.seriesIds,
//                            onChange: handleSeriesChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'series',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Series',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem>

//                   {/* Color Dropdown */}
//                   <GridItem>
//                      {renderDynamicDropdown(
//                         'colorId',
//                         'Color',
//                         colorData,
//                         {
//                            value: formData.colorIds,
//                            onChange: handleColorChange,
//                            showCustomNoOptions: true,
//                            openfrom: 'color',
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Color',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem>

//                   {/* RAM Dropdown */}
//                   <GridItem>
//                      {renderDynamicDropdown(
//                         'ramId',
//                         'RAM',
//                         RAM_TYPE,
//                         {
//                            value: formData.ram,
//                            onChange: (value) => handleInputChange('ram', value),
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select RAM',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem>

//                   {/* Storage Dropdown */}
//                   <GridItem>
//                      {renderDynamicDropdown(
//                         'storageId',
//                         'Storage',
//                         STORAGE_TYPE,
//                         {
//                            value: formData.storage,
//                            onChange: (value) => handleInputChange('storage', value),
//                         },
//                         {},
//                         textColor,
//                         false,
//                         'Select Storage',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </GridItem>
//                </Grid>
//             </ModalBody>

//             <ModalFooter>
//                <Button type="submit" colorScheme="green" mr={3}>
//                   Apply Filters
//                </Button>
//                <Button onClick={handleClear}>Reset</Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// }

// export default StockFilter;

import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   useColorMode,
   Grid,
   GridItem,
   Box,
   Text,
   Divider,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBrand } from '../../../../redux/actions/brand';
import { getCategory } from '../../../../redux/actions/category';
import { getSeries } from '../../../../redux/actions/series';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { RAM_TYPE, STORAGE_TYPE } from '../../../../variables/company';
import { getColor } from '../../../../redux/actions/color';
import { getReportStockDetail } from '../../../../redux/actions/reports';
import { useUser } from 'contexts';
import { getDaybook } from '../../../../redux/actions/daybook';
import { getAccount } from '../../../../redux/actions/account';
import { getItems } from '../../../../redux/actions/item';
import { useGlobal } from 'contexts';
import MultiSelectDropdown from 'components/ui/MultiSelectDropdown';
import AddEditForm from '../../masters/Pages/AllAccountMaster/AddEditFormForAccount';
import DaybookForm from '../../masters/Pages/DaybookMaster/DaybookForm';
import ItemForm from '../../masters/Pages/ItemMaster/ItemMasterForm';
import BrandMasterForm from '../../masters/Pages/BrandMaster/BrandMasterForm';
import CategoryMasterForm from '../../masters/Pages/CategoryMaster/CategoryMasterForm';
import SeriesMasterForm from '../../masters/Pages/SeriesMaster/SeriesMasterForm';
import ColorMasterForm from '../../masters/Pages/ColorMaster/ColorMasterForm';

function StockFilter({ isOpen, onClose, companyIds, fromDate, toDate, stockStatus }) {
   const { user } = useUser();
   const dispatch = useDispatch();
   const { userGlobalSettingsData } = useGlobal();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const textColor = isDark ? 'white' : '#9E9E9E';
   const isColorMode = !isDark;

   const brandData = useSelector((state) => state.brand.list || []);
   const categoryData = useSelector((state) => state.category.list || []);
   const seriesData = useSelector((state) => state.series.list || []);
   const colorData = useSelector((state) => state.color.list || []);
   const accountData = useSelector((state) => state.account.list || []);
   const itemData = useSelector((state) => state.item.data || []);
   const daybookData = useSelector((state) => state.daybook.list || []);
   const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
   const globalSettingDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook;
   const shouldShowCompanyDropdownDaybook = globalSettingDaybook || false;
   const globalSettingItem = userGlobalSettingsData?.[0]?.askCompany?.item;
   const shouldShowCompanyDropdownItem = globalSettingItem || false;
   const globalSettingBrand = userGlobalSettingsData?.[0]?.askCompany?.brand;
   const shouldShowCompanyDropdownBrand = globalSettingBrand || false;
   const globalSettingCategory = userGlobalSettingsData?.[0]?.askCompany?.category;
   const shouldShowCompanyDropdownCategory = globalSettingCategory || false;
   const globalSettingSeries = userGlobalSettingsData?.[0]?.askCompany?.series;
   const shouldShowCompanyDropdownSeries = globalSettingSeries || false;
   const globalSettingColor = userGlobalSettingsData?.[0]?.askCompany?.color;
   const shouldShowCompanyDropdownColor = globalSettingColor || false;

   useEffect(() => {
      if (isOpen) {
         dispatch(
            getBrand({
               ...(shouldShowCompanyDropdownBrand &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getCategory({
               ...(shouldShowCompanyDropdownCategory &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getSeries({
               ...(shouldShowCompanyDropdownSeries &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getColor({
               ...(shouldShowCompanyDropdownColor &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getItems({
               companyId: user.loginhistory.companyId,
               ...(shouldShowCompanyDropdownItem &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
               status: true,
            }),
         );
         dispatch(
            getAccount({
               compId: user?.loginhistory?.companyId,
               status: true,
               ...(shouldShowCompanyDropdownAcc &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getDaybook({
               companyId: user.loginhistory.companyId,
               ...(shouldShowCompanyDropdownDaybook &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
      }
   }, [
      companyIds,
      dispatch,
      isOpen,
      shouldShowCompanyDropdownAcc,
      shouldShowCompanyDropdownBrand,
      shouldShowCompanyDropdownCategory,
      shouldShowCompanyDropdownColor,
      shouldShowCompanyDropdownDaybook,
      shouldShowCompanyDropdownItem,
      shouldShowCompanyDropdownSeries,
      user,
   ]);

   const initialFormData = {
      colorIds: [],
      ram: '',
      seriesIds: [],
      categoryIds: [],
      brandIds: [],
      storage: '',
      accountIds: [],
      itemIds: [],
      daybookIds: [],
   };

   const [formData, setFormData] = useState(initialFormData);

   const handleBrandChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, brandIds: selectedValues || [] }));
   };

   const handleCategoryChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, categoryIds: selectedValues || [] }));
   };

   const handleSeriesChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, seriesIds: selectedValues || [] }));
   };

   const handleColorChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, colorIds: selectedValues || [] }));
   };

   const handleAccountChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, accountIds: selectedValues || [] }));
   };

   const handleItemChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, itemIds: selectedValues || [] }));
   };

   const handleDaybookChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, daybookIds: selectedValues || [] }));
   };

   const handleInputChange = (name, value) => {
      setFormData((prev) => ({
         ...prev,
         [name]: value,
      }));
   };

   const hasValue = (value) => {
      if (Array.isArray(value)) {
         return value.length > 0;
      }
      return value !== '' && value !== null && value !== undefined;
   };

   const handleSubmit = (e) => {
      e.preventDefault();

      const payload = {
         companyIds: companyIds.toString(),
         fromDate: fromDate,
         toDate: toDate,
         stockStatus: stockStatus,
      };

      if (hasValue(formData.colorIds)) {
         payload.colorIds = formData.colorIds.toString();
      }

      if (hasValue(formData.ram)) {
         payload.rams = formData.ram.toString();
      }

      if (hasValue(formData.seriesIds)) {
         payload.seriesIds = formData.seriesIds.toString();
      }

      if (hasValue(formData.categoryIds)) {
         payload.categoryIds = formData.categoryIds.toString();
      }

      if (hasValue(formData.brandIds)) {
         payload.brandIds = formData.brandIds.toString();
      }

      if (hasValue(formData.storage)) {
         payload.storages = formData.storage.toString();
      }

      if (hasValue(formData.accountIds)) {
         payload.accIds = formData.accountIds.toString();
      }

      if (hasValue(formData.itemIds)) {
         payload.itemIds = formData.itemIds.toString();
      }

      if (hasValue(formData.daybookIds)) {
         payload.daybookIds = formData.daybookIds.toString();
      }

      dispatch(getReportStockDetail(payload));
      onClose();
   };

   const handleClear = () => {
      setFormData(initialFormData);

      const payload = {
         companyIds: companyIds.toString(),
         fromDate: fromDate,
         toDate: toDate,
         stockStatus: stockStatus,
      };

      dispatch(getReportStockDetail(payload));
   };

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
         <ModalOverlay bg="blackAlpha.600" />
         <ModalContent
            as="form"
            onSubmit={handleSubmit}
            className={`${isDark ? 'bg-gray-800' : 'bg-white'} shadow-2xl`}>
            <ModalHeader
               className={`${isDark
                  ? 'bg-gradient-to-r from-slate-700 to-slate-800 text-white border-b-2 border-slate-600'
                  : 'bg-gradient-to-r from-blue-50 to-indigo-50 text-gray-800 border-b-2 border-blue-200'
                  } px-8 py-6 rounded-t-md`}>
               <Text className="text-2xl font-bold tracking-tight">Filters</Text>
               <Text className={`text-sm font-normal mt-1 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                  Customize your stock report with advanced filters
               </Text>
            </ModalHeader>
            <ModalCloseButton
               className={`${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-800'
                  } mt-4 mr-4`}
            />

            <ModalBody className={`${isDark ? 'bg-gray-800' : 'bg-gray-50'} px-8 py-6`}>
               {/* Account Information Section */}
               <Box className="mb-8">
                  <Box
                     className={`${isDark
                        ? 'bg-gradient-to-r from-emerald-900/40 to-teal-900/40 border-l-4 border-emerald-500'
                        : 'bg-gradient-to-r from-emerald-50 to-teal-50 border-l-4 border-emerald-400'
                        } px-5 py-3 rounded-lg mb-4 shadow-sm`}>
                     <Text
                        className={`text-base font-bold ${isDark ? 'text-emerald-300' : 'text-emerald-700'
                           } tracking-wide`}>
                        📊 ACCOUNT INFORMATION
                     </Text>
                  </Box>

                  <Grid templateColumns="repeat(3, 1fr)" gap={5}>
                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-emerald-500'
                           : 'bg-white border border-gray-200 hover:border-emerald-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        <MultiSelectDropdown
                           label="Account"
                           options={accountData}
                           value={formData.accountIds}
                           onChange={handleAccountChange}
                           placeholder="Select Account"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={AddEditForm}
                           error={''}
                        />
                     </GridItem>

                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-emerald-500'
                           : 'bg-white border border-gray-200 hover:border-emerald-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        {/* {renderDynamicDropdown(
                           'daybookid',
                           'Daybook',
                           daybookData,
                           {
                              value: formData.daybookIds,
                              onChange: handleDaybookChange,
                              showCustomNoOptions: true,
                              openfrom: 'daybook',
                           },
                           {},
                           textColor,
                           false,
                           'Select Daybook',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Daybook"
                           options={daybookData}
                           value={formData.daybookIds}
                           onChange={handleDaybookChange}
                           placeholder="Select Daybook"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={DaybookForm}
                           error={''}
                        />
                     </GridItem>

                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-emerald-500'
                           : 'bg-white border border-gray-200 hover:border-emerald-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        {/* {renderDynamicDropdown(
                           'itemid',
                           'Item',
                           itemData,
                           {
                              value: formData.itemIds,
                              onChange: handleItemChange,
                              showCustomNoOptions: true,
                              openfrom: 'item',
                           },
                           {},
                           textColor,
                           false,
                           'Select Item',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Item"
                           options={itemData}
                           value={formData.itemIds}
                           onChange={handleItemChange}
                           placeholder="Select Item"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={ItemForm}
                           error={''}
                        />
                     </GridItem>
                  </Grid>
               </Box>

               <Divider className={`${isDark ? 'border-gray-600' : 'border-gray-300'} my-6`} />

               {/* Company Product Details Section */}
               <Box className="mb-6">
                  <Box
                     className={`${isDark
                        ? 'bg-gradient-to-r from-blue-900/40 to-indigo-900/40 border-l-4 border-blue-500'
                        : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-400'
                        } px-5 py-3 rounded-lg mb-4 shadow-sm`}>
                     <Text
                        className={`text-base font-bold ${isDark ? 'text-blue-300' : 'text-blue-700'} tracking-wide`}>
                        🏢 COMPANY PRODUCT DETAILS
                     </Text>
                  </Box>

                  <Grid templateColumns="repeat(3, 1fr)" gap={5}>
                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-blue-500'
                           : 'bg-white border border-gray-200 hover:border-blue-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        {/* {renderDynamicDropdown(
                           'brandid',
                           'Brand',
                           brandData,
                           {
                              value: formData.brandIds,
                              onChange: handleBrandChange,
                              showCustomNoOptions: true,
                              openfrom: 'brand',
                           },
                           {},
                           textColor,
                           true,
                           'Select Brand',
                           false,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Brand"
                           options={brandData}
                           value={formData.brandIds}
                           onChange={handleBrandChange}
                           placeholder="Select Brand"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={BrandMasterForm}
                           error={''}
                        />
                     </GridItem>

                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-blue-500'
                           : 'bg-white border border-gray-200 hover:border-blue-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        {/* {renderDynamicDropdown(
                           'categoryid',
                           'Category',
                           categoryData,
                           {
                              value: formData.categoryIds,
                              onChange: handleCategoryChange,
                              showCustomNoOptions: true,
                              openfrom: 'category',
                           },
                           {},
                           textColor,
                           false,
                           'Select Category',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Category"
                           options={categoryData}
                           value={formData.categoryIds}
                           onChange={handleCategoryChange}
                           placeholder="Select Category"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={CategoryMasterForm}
                           error={''}
                        />
                     </GridItem>

                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-blue-500'
                           : 'bg-white border border-gray-200 hover:border-blue-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        {/* {renderDynamicDropdown(
                           'seriesId',
                           'Series',
                           seriesData,
                           {
                              value: formData.seriesIds,
                              onChange: handleSeriesChange,
                              showCustomNoOptions: true,
                              openfrom: 'series',
                           },
                           {},
                           textColor,
                           false,
                           'Select Series',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Series"
                           options={seriesData}
                           value={formData.seriesIds}
                           onChange={handleSeriesChange}
                           placeholder="Select Series"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={SeriesMasterForm}
                           error={''}
                        />
                     </GridItem>

                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-blue-500'
                           : 'bg-white border border-gray-200 hover:border-blue-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        {/* {renderDynamicDropdown(
                           'colorId',
                           'Color',
                           colorData,
                           {
                              value: formData.colorIds,
                              onChange: handleColorChange,
                              showCustomNoOptions: true,
                              openfrom: 'color',
                           },
                           {},
                           textColor,
                           false,
                           'Select Color',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Color"
                           options={colorData}
                           value={formData.colorIds}
                           onChange={handleColorChange}
                           placeholder="Select Color"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={ColorMasterForm}
                           error={''}
                        />
                     </GridItem>

                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-blue-500'
                           : 'bg-white border border-gray-200 hover:border-blue-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        {/* {renderDynamicDropdown(
                           'ramId',
                           'RAM',
                           RAM_TYPE,
                           {
                              value: formData.ram,
                              onChange: (value) => handleInputChange('ram', value),
                           },
                           {},
                           textColor,
                           false,
                           'Select RAM',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="RAM"
                           options={RAM_TYPE}
                           value={formData.ram}
                           onChange={(value) => handleInputChange('ram', value)}
                           placeholder="Select RAM"
                           isRequired={true}
                           showAddButton={false}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={null}
                           error={''}
                        />
                     </GridItem>

                     <GridItem
                        className={`${isDark
                           ? 'bg-gray-700/50 border border-gray-600 hover:border-blue-500'
                           : 'bg-white border border-gray-200 hover:border-blue-400'
                           } rounded-lg p-4 transition-all duration-300 shadow-sm hover:shadow-md`}>
                        {/* {renderDynamicDropdown(
                           'storageId',
                           'Storage',
                           STORAGE_TYPE,
                           {
                              value: formData.storage,
                              onChange: (value) => handleInputChange('storage', value),
                           },
                           {},
                           textColor,
                           false,
                           'Select Storage',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Storage"
                           options={STORAGE_TYPE}
                           value={formData.storage}
                           onChange={(value) => handleInputChange('storage', value)}
                           placeholder="Select Storage"
                           isRequired={true}
                           showAddButton={false}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={null}
                           error={''}
                        />
                     </GridItem>
                  </Grid>
               </Box>
            </ModalBody>

            <ModalFooter
               className={`${isDark ? 'bg-gray-800 border-t-2 border-gray-700' : 'bg-gray-50 border-t-2 border-gray-200'
                  } px-8 py-5 rounded-b-md`}>
               <Button
                  type="submit"
                  className={`${isDark
                     ? 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700'
                     : 'bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600'
                     } text-white font-semibold px-8 py-2 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 mr-3`}
                  colorScheme="green">
                  ✓ Apply Filters
               </Button>
               <Button
                  onClick={handleClear}
                  className={`${isDark
                     ? 'bg-gray-700 hover:bg-gray-600 text-gray-200 border border-gray-600'
                     : 'bg-white hover:bg-gray-100 text-gray-700 border border-gray-300'
                     } font-semibold px-8 py-2 rounded-lg shadow-md transition-all duration-300 transform hover:scale-105`}>
                  ↻ Reset
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
}

export default StockFilter;
